__webpack_require__.p = "/assessment-2/";